<template>
  <i
    class="fas"
    :class="profileInfo('image')"
    :style="'color:' + profileInfo('color')"
  ></i>
</template>

<script>
export default {
  name: "IconProfile",
  props: {
    profileId: { required: true }
  },
  computed: {
    profile() {
      return this.$store.getters.getProfiles.find(t => t._id == this.profileId);
    }
  },
  methods: {
    profileInfo(field) {
      let profile = this.$store.getters.getProfiles.find(
        t => t._id == this.profileId
      );
      return profile?.[field];
    }
  }
};
</script>

<style scoped>
.label {
  margin-bottom: 5px;
}
</style>
